export enum SegmentTypes {
  CUSTOM_DATA_KEY = 'CustomDataKey'
}
